<template>
    <div class="confirm-sms-page">
        <div class="confirm-sms-card">
            <div class="confirm-sms-header">
                <div class="confirm-sms-header__icon">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        class="confirm-sms-icon"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M9 12l2 2l4-4m6 2a9 9 0 11-18 0a9 9 0 0118 0z"
                        />
                    </svg>
                </div>
                <h2>Xác nhận ca test speaking</h2>
            </div>

            <div class="confirm-sms-body">
                <div v-if="loading" class="confirm-sms-loading">
                    <span class="confirm-sms-spinner"></span>
                </div>

                <result-message
                    v-else-if="error"
                    type="error"
                    title="Không thể tải thông tin lịch hẹn!"
                >
                    <p>Vui lòng thử lại sau ít phút.</p>
                </result-message>

                <content-confirm
                    v-else-if="canConfirm"
                    :item="data"
                    :test-input-schedule-item="testInputScheduleItem"
                    @confirm="confirm"
                />

                <notification
                    v-else
                    :item="data"
                    :test-input-schedule-item="testInputScheduleItem"
                />
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";

import ContentConfirm from "./components/ContentConfirm.vue";
import Notification from "./components/Notification.vue";
import ResultMessage from "./components/ResultMessage.vue";
import {
    CONFIRM_TEST_INPUT,
    SHOW_CONFIRM_TEST_INPUT,
} from "@/core/services/store/customer/testInput.module";

const DATE_FORMAT = "HH:mm DD-MM-YYYY";

export default {
    name: "ConfirmSmsTestInput",
    components: {
        ContentConfirm,
        Notification,
        ResultMessage,
    },
    data() {
        return {
            data: null,
            testInputScheduleItem: null,
            loading: true,
            error: false,
        };
    },
    computed: {
        canConfirm() {
            const item = this.testInputScheduleItem;

            return (
                item &&
                Number(item.is_confirm_come_test) === 0 &&
                Number(item.status) !== 4 &&
                this.data &&
                Number(this.data.status) !== 5
            );
        },
    },
    watch: {
        "$route.query.uuid"(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.fetchUsers();
            }
        },
    },
    mounted() {
        this.fetchUsers();
    },
    methods: {
        async fetchUsers() {
            this.loading = true;
            this.error = false;

            try {
                const uuid = this.$route.query.uuid;

                if (!uuid) {
                    this.error = true;
                    return;
                }

                const response = await this.$store.dispatch(SHOW_CONFIRM_TEST_INPUT, {
                    uuid,
                });

                this.data = response.data;
                const scheduleItems = this.data && this.data.test_input_schedule_item
                    ? this.data.test_input_schedule_item
                    : [];
                const scheduleItem = scheduleItems.find((item) => Number(item.type_item_id) === 0);

                if (scheduleItem) {
                    scheduleItem.time_confirm = this.formatDate(scheduleItem.time_confirm);
                    scheduleItem.canceled_at = this.formatDate(scheduleItem.canceled_at);
                    scheduleItem.schedule = this.formatDate(scheduleItem.schedule);
                }

                this.testInputScheduleItem = scheduleItem || null;
            } catch (error) {
                console.error("Có lỗi xảy ra khi tải dữ liệu:", error);
                this.error = true;
            } finally {
                this.loading = false;
            }
        },
        formatDate(value) {
            if (!value) {
                return "";
            }

            return moment(value).format(DATE_FORMAT);
        },
        async confirm(id, value) {
            try {
                const response = await this.$store.dispatch(CONFIRM_TEST_INPUT, {
                    id,
                    value,
                });

                if (!response.data) {
                    if (value) {
                        this.$set(this.testInputScheduleItem, "checkConfirm", 1);
                    } else {
                        this.$set(this.testInputScheduleItem, "checkCancel", 1);
                    }

                    return;
                }

                await this.fetchUsers();
            } catch (error) {
                console.error("Có lỗi xảy ra khi xác nhận:", error);
            }
        },
    },
};
</script>

<style scoped>
.confirm-sms-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
}

.confirm-sms-card {
    width: 100%;
    max-width: 420px;
    overflow: hidden;
    border-radius: 18px;
    background: #ffffff;
    box-shadow: 0 20px 45px rgba(32, 33, 36, 0.18);
}

.confirm-sms-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px;
    background: #f9c74f;
    color: #65558f;
    text-align: center;
}

.confirm-sms-header h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    text-transform: uppercase;
}

.confirm-sms-header__icon {
    width: 56px;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.confirm-sms-icon {
    width: 32px;
    height: 32px;
}

.confirm-sms-body {
    padding: 24px;
}

.confirm-sms-loading {
    display: flex;
    justify-content: center;
    padding: 32px 0;
}

.confirm-sms-spinner {
    width: 32px;
    height: 32px;
    border: 4px solid rgba(101, 85, 143, 0.2);
    border-top-color: #65558f;
    border-radius: 50%;
    animation: confirm-sms-spin 0.8s linear infinite;
}

@keyframes confirm-sms-spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
